<template>
    <a class="c-type-button" :class="{'active': active}">
        <div v-if="!noIcon" @click="$emit('click')" class="wrapping-clickable">
            <slot name="icon">
                <img :src="srcIcon" class="icon" :alt="altIcon">
            </slot>
        </div>
        <div @click="$emit('click')" class="wrapping-clickable">
            <slot></slot>
        </div>
        <div class="wrapper-info">
            <slot name="info">
                <img v-b-modal.modal-eco src="/img/iconos/icon_info_nm.svg" alt="icon_info_nm.svg" class="icon-info">
                <modal-block v-cloak title="Ecológico" :href="route('help.details','ecologica')" desing="ecologico" refer="eco">
                    Plantas con certificado ecológico producidas bajo
                    la normativa de producción ecológica UE 834/2007.
                </modal-block>
            </slot>
        </div>
    </a>
</template>

<script>
    export default {
        name: "TypeButton",
        props: {
            noIcon: {
                type: Boolean,
                default: false
            },
            srcIcon: {
                type: String,
                default: ''
            },
            altIcon: {
                type: String,
                default: ''
            },
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

    .c-type-button {
        text-decoration: none;
        line-height: 18px;
        color: #333;
        white-space: nowrap;
        border: 3px solid #fec82f;
        display: inline-flex;
        justify-content: space-evenly;
        align-items: stretch;
    }

    .c-type-button > * {
        padding: 0.5em 0.15em;
    }

    .c-type-button > :first-child {
        padding-left: 0.3em;
    }

    .c-type-button > :last-child {
        padding-right: 0.3em;
    }

    .c-type-button.active {
        background-color: #FDC832;
    }

    .c-type-button > .wrapping-clickable {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-weight: bold;
        flex: 1 0 auto;
    }

    .c-type-button > .wrapper-info {
        flex: 1 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .c-type-button img.icon {
        height: 1.5em;
        width: auto;
    }

    .c-type-button img.icon-info {
        height: 1em;
    }

    .c-type-button i {
        position: relative;
        right: 15px;
        z-index: 5;
    }

     .c-type-button.active {
         background-color: #FDC832;
     }

    @media (min-width: 992px) {

        .c-type-button {
            border-width: 5px;
        }

        .c-type-button .wrapping-clickable {
        }

        .c-type-button img.icon {
            height: 2.2em;
            width: auto;
        }
    }

</style>
